<div class="container_form">
  <a routerLink="/"><img src="assets/images/logo.png" class="logo_kingwork" /></a>
  <ng-content></ng-content>
</div>
